// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"48a84c66","752":"9fcbe4e0","827":"7b56394c"}[chunkId] + ".chunk.css";
};